import { Component, DestroyRef, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CmsItem, DefaultColorPickerValues } from '@coin/shared/cms/util';
import { LegacyComponentsModule } from '@coin/shared/core/feature-legacy-components';
import { V2ButtonComponent, V2NumberInputComponent } from '@coin/shared/core/ui-storybook';
import { TranslateModule } from '@ngx-translate/core';
import { SelectMediaComponent } from '../../../dialogs/shared/select-media/select-media.component';
import { EmailSliderComponent } from '../../shared/email-slider/email-slider.component';

@Component({
  selector: 'coin-email-video',
  standalone: true,
  templateUrl: './email-video.component.html',
  imports: [
    V2NumberInputComponent,
    V2ButtonComponent,
    TranslateModule,
    FormsModule,
    EmailSliderComponent,
    MatFormFieldModule,
    LegacyComponentsModule
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './email-video.component.scss'
})
export class EmailVideoComponent implements OnInit {
  @Input({ required: true }) item: CmsItem<'video'>;
  @Input() contentEdit = false;
  @Input() showBackgroundPicker = false;

  readonly defaultHeight = 'auto';

  private dialog = inject(MatDialog);
  private destroyRef = inject(DestroyRef);

  public editVideo(): void {
    SelectMediaComponent.openDialog(this.dialog, { mediaType: 'video' })
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(newImage => {
        if (newImage) {
          this.item.link = newImage.mediaUrl;
        }
      });
  }

  ngOnInit(): void {
    this.setDefaultBackgroundColor();
  }

  private setDefaultBackgroundColor(): void {
    this.item.backgroundColor = this.item.backgroundColor || DefaultColorPickerValues.backgroundColor;
  }
}
